import { render } from "./annualreport.vue?vue&type=template&id=5b89490b"
import script from "./annualreport.vue?vue&type=script&lang=js"
export * from "./annualreport.vue?vue&type=script&lang=js"

import "./annualreport.vue?vue&type=style&index=0&id=5b89490b&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__